import { ReactNode } from 'react';
import fallbacks from './fallbackValues';
import { SymmetricVerticalBarChartProps } from '@components/report/chart/symmetric-vertical-bar-chart/SymmetricVerticalBarChart';

type Status = {
	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
};

export const getHashtagsByStatus = (
	bannerHashtags: string[] | undefined,
	status: Status,
) => {
	const { isLoading, isError, lackOfPermission } = status;

	if (isLoading || isError) return fallbacks.bannerHashtags.empty;
	if (lackOfPermission) return fallbacks.bannerHashtags.example;
	if (bannerHashtags && bannerHashtags.length > 0) return bannerHashtags;
	else return [];
};

const UNABLE_TO_ANALYZE = '현재 데이터를 준비 중이거나 분석할 수 없는 상태';
export const getHashtagsString = (hashtags: string[]) => {
	if (hashtags.length === 0) return UNABLE_TO_ANALYZE;

	return hashtags.map((item) => `#${item}`).join(', ');
};

export const getPostMetricsByStatus = (postMetrics: ReactNode, status: Status) => {
	const { isLoading, isError, lackOfPermission } = status;
	if (isLoading || lackOfPermission) return fallbacks.postMetrics.examples;
	if (isError || !postMetrics) return fallbacks.postMetrics.empty;
	return postMetrics;
};

export const getCategoriesByStatus = (
	categories: SymmetricVerticalBarChartProps,
	status: Status,
) => {
	const { isLoading, isError, lackOfPermission } = status;
	if (isLoading || isError || categories?.topData?.length === 0)
		return fallbacks.categories.empty;
	if (lackOfPermission) return fallbacks.categories.example;
	return categories;
};
